import React from "react"
import styles from "./Divider.module.css"

const Divider = () => <div className={styles.divider} />

export default Divider
